import React from 'react';
import { ApolloError } from 'apollo-client/errors/ApolloError';
import { getErrorMessages } from '../../modules/errors';

import style from './style.module.scss';

interface Props {
  error: ApolloError;
  className?: string;
  showIcon: boolean;
}

export default ({ error, className, showIcon = true }: Props) => {
  return (
    <div className={[style.container, className].join(' ')}>
      {showIcon && (
        <svg
          className={style.icon}
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 96 96"
          enableBackground="new 0 0 96 96"
        >
          <path d="M87.46,59.884c-0.38-0.54-0.992-0.86-1.647-0.86H54.916c0.98-7.08,1.424-13.644,1.352-19.635  c0.053-0.272,0.053-0.556-0.012-0.828c-0.191-9.4-1.672-17.336-4.4-23.472c1.148-0.644,2.836-1.224,4.789-1.332  c2.08-0.116,5.027,0.252,7.359,2.708c2.9,3.052,5.08,5.332,7.176,6.896c-3.939,1.1-8.543,1.992-10.871,0.444  c-0.984-0.652-1.537-1.78-1.692-3.468c-0.104-1.092-1.084-1.916-2.177-1.804c-1.1,0.1-1.907,1.08-1.808,2.18  c0.269,2.916,1.44,5.084,3.464,6.428c1.625,1.076,3.633,1.476,5.78,1.476c4.067,0,8.632-1.436,12.056-2.524l1.416-0.436  c0.893-0.272,1.477-1.116,1.416-2.048c-0.06-0.932-0.752-1.688-1.664-1.844c-3-0.5-5.408-3.032-10.191-8.064  c-2.645-2.772-6.364-4.184-10.488-3.936c-2.296,0.132-4.58,0.804-6.376,1.776c-2.012-3.364-4.496-6.016-7.432-7.852  c-6.832-4.26-15.432-3.472-23.6,2.184c-2.48,1.72-3.844,4.816-3.648,8.28c0.208,3.696,2.092,6.932,4.92,8.456  c6.276,3.376,10.276,1.968,12.104,0.828c2.356-1.468,3.696-4.024,3.588-6.836c-0.044-1.1-0.996-1.944-2.076-1.92  c-1.104,0.044-1.964,0.976-1.92,2.08c0.052,1.36-0.588,2.584-1.712,3.284c-1.852,1.156-4.804,0.812-8.092-0.952  c-1.584-0.856-2.692-2.884-2.824-5.16c-0.12-2.076,0.604-3.852,1.932-4.768c6.892-4.768,13.708-5.508,19.208-2.084  c6.676,4.172,10.628,13.824,11.564,27.252c-2.108-1.416-4.617-2.592-7.277-3.256c-5.856-1.464-11.588-0.472-16.156,2.808  c-8.892,6.38-13.376,9.604-18.388,9.472c-0.828,0.02-1.748,0.6-1.98,1.5S8.44,46.692,9.26,47.12c4.356,2.296,13.56,6.54,22,6.54  c2.968,0,5.844-0.524,8.376-1.844c4.548-2.368,7.272-6.904,8.104-13.464c0.14-1.096-0.64-2.1-1.736-2.244  c-1.068-0.136-2.096,0.636-2.236,1.744c-0.664,5.252-2.62,8.664-5.984,10.416c-5.252,2.744-13.644,0.996-21.18-2.108  c3.924-1.548,8.144-4.58,14.372-9.048c4.576-3.28,9.504-2.988,12.828-2.156c3.94,0.984,6.98,3.064,8.448,4.764  c0.061,5.88-0.393,12.345-1.38,19.3H17.8c-0.656,0-1.268,0.32-1.644,0.86c-0.372,0.54-0.46,1.228-0.228,1.845l12,32  c0.292,0.771,1.04,1.295,1.872,1.295h44c0.832,0,1.58-0.516,1.872-1.295l12-32C87.916,61.107,87.828,60.42,87.46,59.884z"></path>
        </svg>
      )}

      <div className={style.messageContainer}>
        <div className={style.message}>Error</div>
        <div className={style.detail}>
          {getErrorMessages(error).map((message, i) => (
            <div key={i}>{message}</div>
          ))}
        </div>
      </div>
    </div>
  );
};
